import { loadStripe } from '@stripe/stripe-js';
import { env } from 'src/env';
import { isEnterprise } from 'src/utils/general';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
export const stripePromise = !isEnterprise
  ? loadStripe(env.REACT_APP_STRIPE_PK)
  : Promise.resolve(null);
